export default {
    namespaced: true,

    state: {
        /**
         * Itens do carrinho
         * @param {number} Item.UnitPrice
         * @param {number} Item.Quantity
         * @param {string} Item.Name
         * @param {string} Item.Description
         * @param {number} Item.TypeId
         * @param {string} Item.Sku
         * @param {string} Item.ZipCode
         * @param {number} Item.Weight
         * @param {boolean} Item.ShowDescription
         */
        Items: [],
        Discount: null
    },
    getters:{
        getCartDiscount: state => state.Discount || null
    },

    mutations: {
        /**
         * Mapeia o response da api para o módulo
         */
        setFromRequest(state, data) {
            state.Items = data.ShoppingCartItens;
            state.Discount = data.Discount;
        }
    }
};
